class ProductAddons {
  constructor() {
    this.addonsContainer = document.querySelector('[data-product-addons]');
    if (!this.addonsContainer) return;

    this.checkboxes = this.addonsContainer.querySelectorAll('.addon-checkbox');
    this.productForm = document.querySelector('product-form form')
                    || document.querySelector('form[action="/cart/add"]');

    this.init();
  }

  init() {
    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => this.handleCheckboxChange(e));
    });

    this.initPersonalizationFields();
    this.interceptFormSubmit();
  }

  handleCheckboxChange(e) {
    const checkbox = e.target;
    const addonItem = checkbox.closest('.addon-item');
    const variantSelector = addonItem.querySelector('.addon-variant-selector');
    const personalizationFields = addonItem.querySelector('.addon-personalization-fields');

    if (variantSelector) {
      if (checkbox.checked) {
        variantSelector.hidden = false;
      } else {
        variantSelector.hidden = true;
        const select = variantSelector.querySelector('select');
        if (select) select.value = '';
      }
    }

    if (personalizationFields) {
      personalizationFields.hidden = !checkbox.checked;
      if (!checkbox.checked) {
        const textInput = personalizationFields.querySelector('[data-personalization-text]');
        if (textInput) textInput.value = '';
        const charCount = personalizationFields.querySelector('[data-char-current]');
        if (charCount) charCount.textContent = '0';
        const radios = personalizationFields.querySelectorAll('input[type="radio"]');
        radios.forEach(r => { r.checked = false; });
      }
    }
  }

  initPersonalizationFields() {
    const textInput = this.addonsContainer.querySelector('[data-personalization-text]');
    if (textInput) {
      const charCount = this.addonsContainer.querySelector('[data-char-current]');
      textInput.addEventListener('input', () => {
        if (charCount) charCount.textContent = textInput.value.length;
      });
    }
  }

  interceptFormSubmit() {
    if (!this.productForm) return;

    document.addEventListener('submit', (e) => {
      if (e.target !== this.productForm) return;

      const validationError = this.validateAddons();
      if (validationError) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert(validationError);
        return;
      }

      const selectedAddons = this.getSelectedAddons();
      if (selectedAddons.length === 0) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      this.submitWithAddons(selectedAddons).catch((error) => {
        console.error('Error adding items to cart:', error);
        alert('There was an issue adding items to your cart. Please try again.');
      });
    }, true);
  }

  async submitWithAddons(selectedAddons) {
    const formData = new FormData(this.productForm);
    const mainProductPayload = this.formDataToObject(formData);

    // Grab the product title from the page for the "For:" label on name tag line items
    const productTitle = document.querySelector('.product__title')?.innerText?.trim()
                      || document.title;

    const items = [mainProductPayload];

    for (const addon of selectedAddons) {
      const item = {
        id: parseInt(addon.id, 10),
        quantity: 1
      };
      if (addon.properties) {
        item.properties = {
          ...addon.properties,
          'For': productTitle
        };
      }
      items.push(item);
    }

    await this.addItemsToCart(items);
    this.onCartUpdated();
  }

  formDataToObject(formData) {
    const obj = {};
    for (const [key, value] of formData.entries()) {
      obj[key] = value;
    }
    if (obj.id) obj.id = parseInt(obj.id, 10);
    if (!obj.quantity) obj.quantity = 1;
    return obj;
  }

  validateAddons() {
    let error = null;

    this.checkboxes.forEach(checkbox => {
      if (error) return;
      if (!checkbox.checked) return;

      const addonItem = checkbox.closest('.addon-item');
      const variantSelect = addonItem.querySelector('[data-addon-variant-select]');

      if (variantSelect && !variantSelect.value) {
        error = `Please select an option for ${checkbox.dataset.addonName} before adding to cart.`;
        return;
      }

      if (checkbox.classList.contains('addon-checkbox--personalization')) {
        const fields = addonItem.querySelector('.addon-personalization-fields');
        const textInput = fields.querySelector('[data-personalization-text]');
        const selectedColor = fields.querySelector('input[type="radio"]:checked');

        if (!textInput.value.trim()) {
          error = 'Please enter the text for your name tag.';
          return;
        }
        if (!selectedColor) {
          error = 'Please choose a leather color for your name tag.';
          return;
        }
      }
    });

    return error;
  }

  getSelectedAddons() {
    const selected = [];

    this.checkboxes.forEach(checkbox => {
      if (!checkbox.checked) return;

      const addonItem = checkbox.closest('.addon-item');
      const variantSelect = addonItem.querySelector('[data-addon-variant-select]');

      let variantId;
      if (variantSelect) {
        variantId = variantSelect.value;
        if (!variantId) return;
      } else {
        variantId = checkbox.dataset.variantId;
      }

      const addonData = {
        id: variantId,
        name: checkbox.dataset.addonName
      };

      if (checkbox.classList.contains('addon-checkbox--personalization')) {
        const fields = addonItem.querySelector('.addon-personalization-fields');
        const textInput = fields.querySelector('[data-personalization-text]');
        const selectedColor = fields.querySelector('input[type="radio"]:checked');

        addonData.properties = {
          'Personalization': textInput.value.trim(),
          'Leather Color': selectedColor ? selectedColor.value : ''
        };
      }

      selected.push(addonData);
    });

    return selected;
  }

  async addItemsToCart(items) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.description || 'Failed to add items to cart');
    }

    return response.json();
  }

  onCartUpdated() {
    window.location.href = '/cart';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductAddons());
} else {
  new ProductAddons();
}